export function dstUrl(token: string, redirectUrl: string) {
    const URLS = process.env.NEXT_PUBLIC_DST_URLS!.split(',').map((url) => url.trim());
    return `${URLS[0]}/v4/set-token?token=${token}&redirect=${encodeURIComponent(redirectUrl)}&${URLS.slice(1)
        .map((url) => `dst=${url}`)
        .join('&')}`;
}
